import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {schemaFieldsetName} from 'schemas/schema-interface/util/schemaFieldsetName';
import SchemaPrefixInput from 'schemas/SchemaPrefixInput';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {InputErrorMessageStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import uniqueId from 'util/uniqueId';

import {SchemaInterface} from './SchemaInterfaceConstants';

export interface SchemaInterfacePrefixInputProps {
  interface: SchemaInterface | null;
  isRequired: boolean;
  isWritable: boolean;
  prefix?: string | null;
  onPrefixChange: (prefix: string) => void;
  dataTestAttrs?: DataTestAttrs;
}

export default function SchemaInterfacePrefixInput(props: SchemaInterfacePrefixInputProps): JSX.Element {
  const [shouldShowEmptyValueNotAllowed, setShouldShowEmptyValueNotAllowed] = React.useState<boolean>(false);
  function validateAndChangePrefix(prefix: string): void {
    if (prefix === '' && props.interface != null && props.interface.schemas.length > 0) {
      setShouldShowEmptyValueNotAllowed(true);
    } else {
      props.onPrefixChange(prefix);
      setShouldShowEmptyValueNotAllowed(false);
    }
  }

  const prefixInput = (
    <div className={css(styles.prefixInput)}>
      <SchemaPrefixInput
        isBeingCreated={props.interface == null}
        isRequired={props.isRequired}
        isWritable={props.isWritable}
        prefix={props.prefix}
        onPrefixChange={validateAndChangePrefix}
        dataTestAttrs={props.dataTestAttrs}
        emptyValueAllowed={true}
      />
    </div>
  );
  if (shouldShowEmptyValueNotAllowed) {
    return (
      <InputWrapper
        id={uniqueId('schemaInterfacePrefixInput')}
        error={{
          message: `Prefix cannot be unset while schemas apply this ${schemaFieldsetName()}`,
          style: InputErrorMessageStyle.ERROR,
        }}
      >
        {prefixInput}
      </InputWrapper>
    );
  }
  return prefixInput;
}

const styles = StyleSheet.create({
  prefixInput: {
    width: '100%',
  },
});
